module.exports = __webpack_public_path__ + "img/ge.fabf9a04.svg";